import { Translate } from '@dreryk/react-common';
import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth, StyledFlex } from '@dreryk/react-components';

import { visitPatientPregnancyStatusTranslationKeys } from '../../translations';

import { PatientPregnancyMarkingForm } from './PatientPregnancyMarkingForm';
import { PatientPregnancyMarkingModalConfirmButton } from './PatientPregnancyMarkingModalConfirmButton';

type PatientPregnancyMarkingModalProps = {
   readonly visitId: number;
   readonly onClose: VoidFunction;
   readonly onMark: VoidFunction;
};

export const PatientPregnancyMarkingModal = (props: PatientPregnancyMarkingModalProps): JSX.Element => {
   return (
      <Modal
         title={visitPatientPregnancyStatusTranslationKeys.markingPregnancy}
         testId={'markPatientPregnancy'}
         width={ModalWidth.NORMAL}
      >
         <StyledFlex direction={'column'} gap={'20px'}>
            <Translate>{visitPatientPregnancyStatusTranslationKeys.shouldMarkPregnancy}</Translate>
            <PatientPregnancyMarkingForm>
               {({ handleSubmit, formState }) => (
                  <>
                     <PatientPregnancyMarkingModalConfirmButton
                        visitId={props.visitId}
                        handleSubmit={handleSubmit}
                        onSuccess={() => {
                           props.onMark();
                           props.onClose();
                        }}
                        registerMedicalEvent
                     />
                     <PatientPregnancyMarkingModalConfirmButton
                        visitId={props.visitId}
                        handleSubmit={handleSubmit}
                        onSuccess={() => {
                           props.onMark();
                           props.onClose();
                        }}
                        registerMedicalEvent={false}
                     />
                     <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                     <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  </>
               )}
            </PatientPregnancyMarkingForm>
         </StyledFlex>
      </Modal>
   );
};
